import { useEffect, useRef, useState } from "react";
import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
// import CommitmentCelebration from "./CommitmentCelebration";

const stats = [
  { end: 8, label: "Consultorios Médicos" },
  { end: 10, label: "Habitaciones" },
  {
    end: 2,
    label: (
      <>
        Quirófanos con {/* <br /> */}
        área de
        <br />
        recuperación
      </>
    ),
  },
];

const CommitmentStats = () => {
  const lastItemRef = useRef(null);
  // const [isVisible, setIsVisible] = useState(false);

  // useEffect(() => {
  //   const element = lastItemRef.current;
  //   if (!element) return;
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       setIsVisible(entry.isIntersecting);
  //     },
  //     { threshold: 0.5 },
  //   );
  //   observer.observe(element);
  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  return (
    <Box sx={design.Container}>
      <CustomText sx={design.Tag}>MEDAM EN NÚMEROS</CustomText>
      <CustomText sx={design.Title}>
        La dimensión de nuestro
        <br />
        compromiso
      </CustomText>
      <Grid container sx={design.Grid}>
        <Grid size={design.item6} sx={design.LastItem}>
          {/* <CommitmentCelebration isVisible={isVisible} /> */}
          <CustomText sx={design.LastLabel}>
            Los quirófanos más seguros de la zona
          </CustomText>
        </Grid>
        {stats.map((item, index) => (
          <Grid key={index} size={design.item3} sx={design.Item}>
            <CustomText sx={design.Number}>{item.end}</CustomText>
            <CustomText sx={design.Label}>{item.label}</CustomText>
          </Grid>
        ))}
        <Grid ref={lastItemRef} size={design.item6} sx={design.LastItem}>
          {/* <CommitmentCelebration isVisible={isVisible} /> */}
          <CustomText sx={design.LastLabel}>
            Hospital privado con
            <br />
            innovación del sistema
            <br />
            paciente-enfermero
          </CustomText>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CommitmentStats;

const design = {
  Container: {
    py: { xs: 5, md: 7 },
    px: { xs: 2, md: 4 },
    backgroundColor: "#F7F7F8",
    textAlign: "center",
    overflow: "hidden",
  },
  Tag: {
    color: "#7A2FA4",
    fontWeight: 700,
    letterSpacing: 2.5,
    textTransform: "uppercase",
    mb: 1.5,
    fontFamily: "Nunito",
    fontSize: 12,
    lineHeight: 1,
    textAlign: "center",
    width: "100%",
  },
  Title: {
    color: "#162E84",
    fontWeight: 800,
    letterSpacing: 0.5,
    fontFamily: "Nunito",
    fontSize: { xs: 32, sm: 35, md: 38, lg: 40 },
    lineHeight: 0.95,
    textAlign: "center",
  },
  Grid: {
    mt: { xs: 5, md: 4.5 },
    alignItems: "start",
    justifyContent: "center",
  },
  Item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: 90,
  },
  Number: {
    color: "#7A2EA8",
    fontFamily: "Nunito",
    fontSize: { xs: 35, md: 38, lg: 40 },
    fontWeight: 800,
    lineHeight: 1,
    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
  },
  Label: {
    color: "#7A2FA4",
    fontFamily: "Nunito",
    fontSize: { xs: 16, md: 13, lg: 17 },
    fontWeight: 500,
    lineHeight: 1.15,
    textAlign: "center",
    mt: 1,
  },
  LastItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    textAlign: "center",
    marginTop: 0,
    minHeight: 90,
  },
  LastLabel: {
    color: "#7A2FA4",
    fontFamily: "Nunito",
    fontSize: { xs: 14, md: 13, lg: 17 },
    fontWeight: 700,
    lineHeight: 1.8,
    textAlign: "center",
    maxWidth: { xs: "100%", md: 300, lg: 300 },
    position: "relative",
    zIndex: 3,
  },
  LastL: {
    color: "#737373",
    fontFamily: "Nunito",
    fontSize: { xs: 20, md: 15, lg: 20 },
    fontWeight: 700,
    lineHeight: 1.8,
    textAlign: "center",
    marginTop: 5,
  },
  item6: { xs: 12, sm: 12, md: 1.8 },
  item3: { xs: 4, sm: 2, md: 1.8 },
};
